// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__9hSel","top":"styles_top__1al7p","left":"styles_left__3WeCQ","description":"styles_description__Op-m1"};